<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} ` : `Livratos – Livraison sur chantier pour le BTP`
    }}</template>
  </metainfo>

  <NavBase v-if="showNavbar" />
  <!--<NavBlog />-->
  <router-view :key="$route.fullPath" />
  <div v-if="showFooter">
    <LegalBar />
    <FooterBase />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import NavBase from "@/components/NavBase.vue";
//import NavBlog from "@/components/NavBlog.vue";
import LegalBar from "@/components/plugins/LegalBar.vue";
import FooterBase from "@/components/FooterBase.vue";

export default {
  components: { NavBase, FooterBase, LegalBar },
  setup() {
    useMeta({
      title: "Livratos – Livraison sur chantier pour le BTP",
      description: [
        {
          content:
            "Livratos est la plateforme de livraison sur chantier dédiée au BTP. Fournisseurs de matériaux, artisans et livreurs indépendants organisent leurs livraisons simplement : missions de livraison BTP, transport de matériel sur chantier et suivi en temps réel partout en France.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr",
        },
      ],
    });
  },
  data() {
    return {
      showNavbar: true,
      showFooter: true,
    };
  },
};
</script>

<style lang="scss"></style>
